import { Component, OnInit } from '@angular/core';
import { InterfacesService } from '../interfaces.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { UntypedFormControl } from '@angular/forms';
import {TipoInterfaces} from "@shared/enums/TipoInterfaces";


@Component({
  selector: 'app-interfaz-sap',
  templateUrl: './interfaz-sap.component.html',
  styleUrls: ['./interfaz-sap.component.scss']
})
export class InterfaceSapComponent implements OnInit {

  interfaces;
  interfacesFiltradas;
  interfazSeleccionada;
  error;
  mensajeError;
  cargandoInterfaces: boolean;
  buscadorFormControl = new UntypedFormControl();

  constructor(private interfacesService: InterfacesService, private spinner: NgxSpinnerService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.obtenerInterfaces();
  }

  obtenerInterfaces() {
    this.cargandoInterfaces = true;
    this.spinner.show('spinnerGrafico');
    this.interfacesService.obtenerInterfazDesdeLogicApp(TipoInterfaces.SAP).then(interfaces => {
      this.error = false;
      const interfacesLista = this.transformarJSON(interfaces);

      this.interfaces = [];
      this.interfaces.push({ nombre: "Monitor Documentos Contabilizados", estado: null })
      this.interfaces = this.interfaces.concat(interfacesLista);

      this.interfacesFiltradas = this.interfaces;

      this.cargandoInterfaces = false;
      this.spinner.hide('spinnerGrafico');
    }).catch(() => {
      this.error = true;
      this.interfaces = [];
      //this.interfaces.push({ nombre: "Monitor Asientos", estado: null })
      this.interfacesFiltradas = this.interfaces;
      this.mensajeError = 'Error al conectarse con la interfaz SAP'
      this.cargandoInterfaces = false;
      this.spinner.hide('spinnerGrafico');
    })
  }

  filtrarInterfaces() {
    this.interfacesFiltradas = this.interfaces.filter(i => i.nombre.toLowerCase().includes(this.buscador.value.toLowerCase()));
  }

  transformarJSON(jsonData) {
    const interfazMapeo = {
      "AsientosContableLP0": "Documentos a Contabilizar",
      "AlicuotasARBA": "Alicuotas ARBA",
      "AlicuotasARCIBA": "Alicuotas ARCIBA",
      "AlicuotasRestoProvincias": "Alicuotas Resto Provincias",
      "Cupones": "Cupones"
    };

    return Object.keys(jsonData).map((key) => {
      const registros = jsonData[key];
      let estado = "SinError";
      const pendientes = [];
      const error = [];

      const encabezadoData = {
        "AsientosContableLP0": {
          encabezados: ["Referencia", "Nro. documento interno", "Fecha documento", "Fecha contabilización"],
          registros: (r) => [
            r.Z1BKPF.Referencia,
            r.Z1BKPF.NumeroDocumento,
            this.formatearFecha(r.Z1BKPF.FechaDocumento),
            this.formatearFecha(r.Z1BKPF.FechaContabilizacion)
          ]
        },
        "AlicuotasARBA": {
          encabezados: ["Nro. documento legal", "Nro. documento interno", "Fecha y hora ingreso"],
          registros: (r) => [
            r.ZFIAP_ARBA_ITB_IIBB[0].NroLegalDocumento,
            r.ZFIAP_ARBA_ITB_IIBB[0].NumeroDocInterno,
            this.datePipe.transform(r.FechaHoraIngreso, 'dd/MM/yyy HH:mm a')
          ]
        },
        "AlicuotasARCIBA": {
          encabezados: ["Nro. documento legal", "Nro. documento interno", "Fecha y hora ingreso"],
          registros: (r) => [
            r.ZFIAP_ARBA_ITB_IIBB[0].NroLegalDocumento,
            r.ZFIAP_ARBA_ITB_IIBB[0].NumeroDocInterno,
            this.datePipe.transform(r.FechaHoraIngreso, 'dd/MM/yyy HH:mm a')
          ]
        },
        "AlicuotasRestoProvincias": {
          encabezados: ["Nro. documento legal", "Nro. documento interno", "Fecha y hora ingreso"],
          registros: (r) => [
            r.ZFIGL_ITB_PER_EF_SGC[0].NroLegalDocumento,
            r.ZFIGL_ITB_PER_EF_SGC[0].NumeroDocInterno,
            this.datePipe.transform(r.FechaHoraIngreso, 'dd/MM/yyy HH:mm a')
          ]
        },
        "Cupones": {
          encabezados: ["Número factura", "Número documento SAP", "Fecha y hora ingreso"],
          registros: (r) => [
            r.NumeroFactura,
            r.NumeroDocSAP,
            this.datePipe.transform(r.FechaHoraIngreso, 'dd/MM/yyy HH:mm a')
          ]
        }
      }[key];

      registros.forEach(r => {
        const registroTransformado = encabezadoData.registros(r);
        if (r.Estado.toLocaleLowerCase() === "error") {
          estado = "error";
          error.push(registroTransformado);
        } else if (r.Estado.toLocaleLowerCase === "pendiente") {
          pendientes.push(registroTransformado);
          if (estado.toLocaleLowerCase() !== "error") {
            estado = "pendiente";
          }
        } else {
          pendientes.push(registroTransformado);
        }
      });

      // Si hay registros pendientes y el estado no es "ERROR", asegura que el estado sea "Pendiente"
      if (estado !== "error" && pendientes.length > 0) {
        estado = "pendiente";
      }
      const interfacesSAP = {
        nombre: interfazMapeo[key],
        estado: estado,
        pendientes: {
          encabezados: encabezadoData.encabezados,
          registros: pendientes
        },
        error: {
          encabezados: encabezadoData.encabezados,
          registros: error
        }
      };
      return interfacesSAP;
    });
  }

  formatearFecha(fecha) {
    return `${fecha.slice(6, 8)}/${fecha.slice(4, 6)}/${fecha.slice(0, 4)}`;
  }

  mostrarInterfaz(event) {
    this.interfazSeleccionada = event;
  }

  get buscador() {
    return this.buscadorFormControl;
  }
}
